export const AUTH_STATUS = {
  INVALID: 'invalid',
  BANNED: 'banned',
  OK: 'ok',
  ERROR: 'error',
};
